import { useAppDispatch } from "hooks/hooks";
import { useSelector } from "react-redux";
import ToolboxButton, {
  ToolboxButtonIcon,
} from "Dashboard/components/Buttons/ToolboxButton";
import { useNavigate } from "react-router-dom";
import Popover from "components/Popover/Popover";
import InfoTooltip from "components/Popup/InfoTooltip";
import {
  setNewExpensePopover,
  selectState,
  setSearchExpensePopover,
  getExpensesList
} from "../main.slice";
import NewExpensePopover from "./NewExpensePopover";
import SearchExpensePopover from "./SearchExpensePopover";
import { ICreateExpenseRequestParams } from "Dashboard/scenes/Expenses/domain/ICreateExpenseRequestParams";
import { useForm } from "react-hook-form";
import { useState } from "react";
import { IExpenseSearch } from "Dashboard/scenes/Expenses/domain/IExpenseSearch";
import { SearchType } from "Dashboard/domain/SearchType";
import { areQueryParamsEmpty } from "utils/queryParamsUtil";

const Toolbox = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { newExpensePopover, searchExpensePopover } = useSelector(selectState);

  const {
    handleSubmit,
    register,
    control,
    getValues,
    formState: { errors },
    reset,
  } = useForm<ICreateExpenseRequestParams>();

  const {
    register: registerSearch,
    handleSubmit: handleSubmitSearch,
    reset: resetSearch,
    control: controlSearch,
    setFocus: setFocusSearch,
    getValues: getValuesSearch,
    setValue: setValueSearch,
  } = useForm<IExpenseSearch>();
  const [searchType, setSearchType] = useState<SearchType>(SearchType.BASIC);

  const isSearchFormEmpty = areQueryParamsEmpty(getValuesSearch());

  return (
    <>
      <nav className="container">
        <InfoTooltip tooltip="Glavni meni">
          <ToolboxButton
            icon={ToolboxButtonIcon.Back}
            onClick={() => navigate('/dashboard')}
          />
        </InfoTooltip>
        <div>
          <InfoTooltip tooltip="Novi" element="span">
            <ToolboxButton
              icon={ToolboxButtonIcon.Add}
              toolbox={true}
              onClick={() => { dispatch(setNewExpensePopover({ isOpen: true })) }}
            />
          </InfoTooltip>
          <InfoTooltip tooltip="Traži" element="span">
            <ToolboxButton
              icon={ToolboxButtonIcon.Search}
              toolbox={true}
              onClick={() => { dispatch(setSearchExpensePopover({ isOpen: true })) }}
            />
          </InfoTooltip>
          {!isSearchFormEmpty
            && (<ToolboxButton
              icon={ToolboxButtonIcon.CancelSearch}
              tiny={true}
              tooltip="Pokaži sve"
              onClick={() => {
                dispatch(getExpensesList({}));
                resetSearch();
              }}
            />)}
          <ToolboxButton
            icon={ToolboxButtonIcon.Print}
            toolbox={true}
            onClick={() => {
              // dispatch(handlePrint());
            }}
          />
        </div>
      </nav>
      <Popover
        isOpen={newExpensePopover.isOpen}
        onClose={() => { dispatch(setNewExpensePopover({ isOpen: false })) }}
        title="Novi trošak"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 155 }}
      >
        <NewExpensePopover
          handleSubmit={handleSubmit}
          register={register}
          control={control}
          getValues={getValues}
          errors={errors}
          reset={reset}
        />
      </Popover>
      <Popover
        isOpen={searchExpensePopover.isOpen}
        onClose={() => { dispatch(setSearchExpensePopover({ isOpen: false })) }}
        title="Pretraga"
        direction="right"
        arrowStyle={{ top: "42px" }}
        position={{ top: 10, left: 215 }}
      >
        <SearchExpensePopover
          handleSubmit={handleSubmitSearch}
          register={registerSearch}
          control={controlSearch}
          reset={resetSearch}
          setFocus={setFocusSearch}
          getValues={getValuesSearch}
          setValue={setValueSearch}
          searchType={searchType}
          setSearchType={setSearchType}
        />
      </Popover>
    </>
  );
};

export default Toolbox;
